import React, { useMemo } from 'react'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { APPLICATION_STRINGS } from '../../strings'
import CloudOffIcon from '@material-ui/icons/CloudOff'
import styles from './NetworkPrinterErrorModal.module.scss'

const NetworkPrintErrorModal = ({ onCancel, type }) => {
  const message = useMemo(() => {
    switch (type) {
      case 'slip':
        return APPLICATION_STRINGS.NETWORK_PRITING_SLIP_OFFLINE_ERROR
      case 'check':
        return APPLICATION_STRINGS.NETWORK_PRITING_CHECK_OFFLINE_ERROR
      case 'receipt':
        return APPLICATION_STRINGS.NETWORK_PRITING_RECEIPT_OFFLINE_ERROR
      default:
        return APPLICATION_STRINGS.NETWORK_PRITING_OFFLINE_ERROR
    }
  }, [type])
  return (
    <ConfirmModalV2
      classNames={{ container: styles.cotaniner, headerText: styles.headerText }}
      icon={<CloudOffIcon fontSize="large" />}
      onButtonTwoClick={onCancel}
      headerText={message}
      buttonTwoText={APPLICATION_STRINGS.OKAY_BUTTON_TEXT}
      singleButtonOnly
    />
  )
}

export default NetworkPrintErrorModal
